import React, { Component } from 'react';
import cx from 'classnames';
import { IMAGES } from 'src/constants';
import { Helpers, Convert } from 'src/helpers';
import styles from './_mobileSipTransactions.module.scss';

export default class MobileSipTransactions extends Component {
  getDaysInMonth = () => {
    let month = new Date().getMonth();
    let year = new Date().getFullYear();

    let date = new Date(year, month, 1);
    let days = [];
    while (date.getMonth() === month) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return days;
  };

  render() {
    const {
      openSipCalendar,
      isSipCalendar,
      tempSipDate,
      sipDate,
      handleTempSipDateSelect,
      updateSipDate,
      checkoutDetail,
      minAmount,
      minNoOfInstallments,
      amount,
      handleAmountChange,
      errors,
      isLoading,
      handleOnSubmit,
      noOfInstallments,
      handleInstallmentChange,
    } = this.props;
    const dateList = this.getDaysInMonth();

    return (
      <div className={styles['mobile-sip-transactions']}>
        <div>
          <div className={styles['banner']}>
            <div className={styles['banner-inner']}>
              <div className={styles['banner-left']}>
                <img
                  src={checkoutDetail?.oneClickCheckout?.imgLink || IMAGES.MOTILAL_OSWAL}
                  alt="img"
                />
              </div>
              <div className={styles['banner-right']}>
                <div className={styles['banner-right-title']}>
                  {Convert.toCapitalizeLetters(
                    checkoutDetail?.oneClickCheckout?.partner?.name ||
                      checkoutDetail?.oneClickCheckout?.amcName,
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className={styles['divider']} />

          <div className={styles['detail']}>
            <div className={styles['detail-left']}>
              <div className={styles['detail-title']}>Customer Name</div>
              <div className={styles['detail-sub-title']}>
                {checkoutDetail?.oneClickCheckout?.name || '-'}
              </div>
            </div>
            <div className={styles['detail-right']}>
              <div className={styles['detail-title']}>Folio Number</div>
              <div className={styles['detail-sub-title']}>
                {checkoutDetail?.oneClickCheckout?.folioNumber || '-'}
              </div>
            </div>
          </div>

          <div className={styles['divider-two']} />
          <div className={styles['sip-title']}>
            {' '}
            Investing in {checkoutDetail?.oneClickCheckout?.fundName}
          </div>
          <div className={styles['monthly-title']}>Monthly amount to be invested</div>
          <div className={styles['input-group']}>
            <div className={styles['input-container']}>
              <div className={cx(styles['input-box'], styles['input-box-amount'])}>
                <span>₹ </span>
                <input type="number" value={amount} onChange={handleAmountChange} />
              </div>
            </div>
            <div className={cx('input-error', styles['amount-input-error'])}>
              {errors?.e_amount}
            </div>
          </div>
          <div className={styles['min-inv']}>
            Min investment {Convert.toCurrencyValue(minAmount || 0)}
          </div>
          <div className={styles['input-group']}>
            <div className={styles['input-label']}>SIP Date</div>
            <div className={styles['input-container']}>
              <div
                className={cx(styles['input-box'], styles['input-box-sip-date'])}
                onClick={openSipCalendar}
              >
                <input type="text" disabled />
                <div className={styles['input-box-sip-date-text']}>
                  <div className={styles['input-box-sip-date-num']}>
                    {Helpers.ordinalSuffix(sipDate)}&nbsp;
                  </div>
                  <div>of every month</div>
                </div>
                <div className={styles['calendar-icon']}>
                  <img src="/images/cal.svg" alt="calendar" />
                </div>
              </div>
            </div>
          </div>

          <div className={styles['input-group']}>
            <div className={styles['input-label']}>No. of installments</div>
            <div className={styles['input-container']}>
              <div className={styles['input-box']}>
                <input type="number" value={noOfInstallments} onChange={handleInstallmentChange} />
              </div>
            </div>
            <div className={cx('input-error')}>{errors?.e_noOfInstallments}</div>
            <div className={styles['note']}>Min installments - {minNoOfInstallments}</div>
          </div>
        </div>
        <div className={styles['powered-by']}>powered by savvy</div>
        <div className={styles['footer-spacer']} />
        <div
          className={cx(styles['footer'], {
            [styles['disabled-footer']]: isLoading,
          })}
        >
          <button disabled={isLoading} onClick={handleOnSubmit}>
            {isLoading ? 'LOADING...' : 'INVEST NOW'}
          </button>
        </div>

        <div
          className={cx(styles['custom-cal-box'], {
            [styles['custom-cal-box-open']]: isSipCalendar,
          })}
        >
          <div
            className={cx(styles['custom-cal'], {
              [styles['custom-cal-open']]: isSipCalendar,
            })}
          >
            <div className={styles['cal-title']}>SIP Installment Date</div>
            <div className={styles['custom-dates-outer']}>
              <div className={styles['custom-dates-box']}>
                {dateList &&
                  dateList.length > 0 &&
                  dateList.map((d, index) => (
                    <div
                      className={cx(styles['cal-date'], {
                        [styles['cal-date-selected']]: tempSipDate === index + 1,
                      })}
                      key={index}
                      onClick={() => handleTempSipDateSelect(index + 1)}
                    >
                      {index + 1}
                    </div>
                  ))}
              </div>
            </div>
            <div className={styles['cal-title']}>
              Next SIP installment on {Helpers.ordinalSuffix(tempSipDate)} June
            </div>

            <div className={styles['update-btn']}>
              <button onClick={() => updateSipDate(tempSipDate)}>UPDATE</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
